import { theme } from '../Theme';
import { css } from 'react-emotion';

export const eztradStyling = css`
  .content-component-container {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      color: ${theme.colors.almostBlack};
      font-weight: 700;
      text-transform uppercase;
    }
    a {
      font-weight: 500;
      font-size: 1rem;
      letter-spacing: 0.03em;
      font-feature-settings: 'liga' off;
      color: ${theme.colors.black};
      text-transform: none;
      font-variant: normal;
      border-color: ${theme.colors.black};
    }
    blockquote {
      color: ${theme.colors.almostBlack};
    }
  }
`;
